export default {"src":"/_next/static/media/attachment_24.088facca.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};